import React from 'react';
import QuestionBankTab from '../components/QuestionBankTab';

export default function TeacherQuestionBankPage() {
    return (
        <div className="space-y-6" data-testid="teacher-question-bank-page">
            <div>
                <h1 className="text-3xl sm:text-4xl font-black tracking-tight">Question Bank</h1>
                <p className="text-sm text-zinc-500 mt-1">Browse past papers and assign any question to a class.</p>
            </div>
            <QuestionBankTab />
        </div>
    );
}
